module.exports = __webpack_public_path__ + "static/fipclilacrain1-8f3631707cd9b6c9c04db1ab247cbe3a.jpeg";